import { render, staticRenderFns } from "./TestPaperView.vue?vue&type=template&id=22946544&scoped=true&"
import script from "./TestPaperView.vue?vue&type=script&lang=js&"
export * from "./TestPaperView.vue?vue&type=script&lang=js&"
import style0 from "./TestPaperView.vue?vue&type=style&index=0&id=22946544&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22946544",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QFile from 'quasar/src/components/file/QFile.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QSlider from 'quasar/src/components/slider/QSlider.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QSpinnerFacebook from 'quasar/src/components/spinner/QSpinnerFacebook.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn,QSpace,QFile,QIcon,QSeparator,QToolbar,QBtnGroup,QTabs,QTab,QTabPanels,QTabPanel,QDialog,QCard,QCardSection,QItemLabel,QItem,QSlider,QCardActions,QInnerLoading,QSpinnerFacebook});qInstall(component, 'directives', {ClosePopup});
